import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'via-grid-urgent-flag',
  imports: [CommonModule, TooltipModule],
  standalone: true,
  template: `
    <i
      *ngIf="params.isUrgent"
      tooltipPosition="top"
      pTooltip="Urgent"
      class="pi pi-flag-fill color-red ml-2 text-xl flex"
    ></i>
  `,
})
export class GridUrgentFlagComponent implements ICellRendererAngularComp {
  params: any;

  agInit(params: ICellRendererParams) {
    this.params = params;
  }

  refresh() {
    return false;
  }
}
